import gql from 'graphql-tag'

export const CreateExportWelders = gql`
  mutation createJobs($project_id: Int, $type: String = "WlWelders::Jobs::ExportWelders", $args: String) {
  createJobs(project_id: $project_id, type: $type, args: $args) {
      job {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Welders/export_welders/mutations.js